import {
  adminChildren,
  coletasChildren,
  creditoChildren,
  etcRootMenu,
  gestaoFretesChildren,
  ofertasAgregamentoChildren,
  ofertasFreteChildren
} from "src/app/core/route/admin-etc.routes";
import { Menu } from "./menu-items.model";

const adminEtcMenu: Menu[] = [
  {
    state: '',
    name: etcRootMenu[0],
    type: 'sub',
    children: [
      { ...adminChildren[0] },
      { ...adminChildren[1] },
    ],
  },
  {
    state: '',
    name: etcRootMenu[1],
    type: 'sub',
    children: [
      { ...ofertasFreteChildren[0] },
      { ...ofertasFreteChildren[1] },
    ]
  },
  {
    state: '',
    name: etcRootMenu[2],
    type: 'sub',
    children: [
      { ...ofertasAgregamentoChildren[0] },
      { ...ofertasAgregamentoChildren[1] },
    ]
  },
  {
    state: '',
    name: etcRootMenu[3],
    type: 'sub',
    children: [
      { ...coletasChildren[0] },
      { ...coletasChildren[1] },
    ]
  },
  {
    state: '',
    name: etcRootMenu[4],
    type: 'sub',
    children: [
      { ...gestaoFretesChildren[0] },
      { ...gestaoFretesChildren[1] },
      { ...gestaoFretesChildren[2] },
      { ...gestaoFretesChildren[3] },
    ]
  },
  {
    state: '',
    name: etcRootMenu[5],
    type: 'sub',
    children: [
      { ...creditoChildren[0] },
      { ...creditoChildren[1] },
      { ...creditoChildren[2] },
    ]
  }
];

export class MenuItemsEtc {
  getMenuItem(): Menu[] {
    return adminEtcMenu;
  }
}
